<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          KEY HIGHLIGHT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Message List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon class="mr-4"></v-icon>
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
          <v-flex
            xs12
            class="text-right"
            v-if="hasPermission('key_highlight', 'view')"
          >
            <v-btn
              id="add-message"
              depressed
              color="secondblue"
              class="white--text"
              :to="{ name: 'keyHighlightCreate' }"
            >
              <v-icon left dark>add</v-icon>
              Add new message
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :must-sort="true"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template v-slot:body="{ items }">
            <tbody v-if="items.length > 0">
              <tr v-for="(item, index) in items" :key="index">
                <td>
                  {{ item.start ? formatDate(item.start) : '-' }}
                </td>
                <td>
                  {{ item.end ? formatDate(item.end) : '-' }}
                </td>
                <td>
                  {{ item.message ? item.message : '-' }}
                </td>
                <td class="text-center">
                  <v-btn
                    icon
                    :id="'btn-detail' + item.id"
                    @click="detail(item.id)"
                  >
                    <v-icon color="green">remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    :id="'btn-edit' + item.id"
                    @click="toEdit(item.id)"
                  >
                    <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
                  </v-btn>
                  <v-btn
                    :id="'btn-edit' + item.id"
                    @click="deleteItem(item.id)"
                    icon
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">
                  No data displayed
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../mixins/ACLMixin';
import paginationMixin from '../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      items: [],
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      breadcrumbs: [
        {
          text: 'Key Highlight',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Message List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      // itemsPerPage: 10,
      headers: [
        { text: 'Start Date', value: 'start', sortable: false },
        { text: 'End Date', value: 'end', sortable: false },
        { text: 'Message', value: 'message', sortable: false },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      timeout: null
    };
  },
  watch: {
    // 'options.page'(value) {
    //   this.getData();
    // },
    'options.itemsPerPage'() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      let { page, itemsPerPage } = this.options;
      return this.$store
        .dispatch('keyHighlight/getAll', {
          page,
          limit: itemsPerPage
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    toEdit(value) {
      this.$router.push({
        params: { id: value },
        name: 'keyHighlightEdit'
      });
    },
    detail(value) {
      this.$router.push({
        name: 'keyHighlightDetail',
        params: { id: value }
      });
    },
    deleteItem(item_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this message!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.$store.dispatch('keyHighlight/delete', item_id).then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Deleted!', data.message.text_en, 'success');
              this.getData();
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'The message has been kept.', 'error');
        }
      });
    }
  }
};
</script>
